import Vue from 'vue'

export async function signIn(context, user) {
    try {
        context.commit('setLoading', true, { root: true })
        
        const response = await Vue.axios({
            method: 'POST',
            url: '/login',
            headers: {
              /*  'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
                'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',*/
                'Accept' : 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                nombre: user.nombre,
                password: user.password,
            }
        })
      
        
        context.commit('auth/setAccessToken', response.data.access_token, { root: true })
        context.commit('auth/setUser', response.data.users, { root: true })
        context.commit('auth/setGlobales', response.data.globales, { root: true })
       
    } catch (e) {
       
        context.commit('auth/authError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function logOut(context, [access_token]) {
    try {
      //  context.commit('auth/logout', null, { root: true })
      //  return;
        if (access_token) {
            context.commit('setLoading', true, { root: true })

            const resuser = await Vue.axios({
                method: 'GET',
                url: '/logout',
                headers: {
                  //  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                
            })
           
            context.commit('auth/logout', resuser, { root: true })
        }

    } catch (e) {
      
        context.commit('auth/authError', e.message, { root: true })
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}

export async function getDatosReserva(context, [id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
                method: 'POST',
                url: '/busquedareservaxid2',
                headers: {
                  //  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                data: {
                    id,
                }
            })
          return response.data; 
          //  context.commit('auth/registro', response, { root: true })
        

    } catch (e) {
      
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}

export async function registrarAcompañante(context, [id, userNew]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
                method: 'POST',
                url: '/registrar_acompanante',
                headers: {
                  //  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                data: {
                    reserva_id: id,
                    nombre: userNew.nombre,
                    telefono1: userNew.telefono1,
                    email: userNew.email,
                    fecha_nac: userNew.fecha_nac,
                    dni: userNew.dni, 
                }
            })
           return response.data; 
          //  context.commit('auth/registro', response, { root: true })
        

    } catch (e) {
      
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




